import PhoneInput from 'react-phone-number-input'
import { tokens } from '@fluentui/react-components'
import 'react-phone-number-input/style.css'

interface Props {
  value: string | undefined
  onChange: (value: string) => void
  disabled?: boolean
}

export function CzPhoneInput({ value, onChange, disabled }: Props) {
  return (
    <div style={{ position: 'relative' }}>
      <PhoneInput
        defaultCountry="CZ"
        value={value || ''}
        onChange={v => onChange(v ?? '')}
        disabled={disabled}
        style={{
          display: 'flex',
          alignItems: 'center',
          border: `1px solid ${tokens.colorNeutralStroke1}`,
          borderRadius: tokens.borderRadiusMedium,
          backgroundColor: tokens.colorNeutralBackground1,
          height: '32px',
          overflow: 'hidden',
        }}
      />
      <style>{`
        /* Wrapper */
        .PhoneInput {
          gap: 0;
        }
        /* Tlačítko výběru státu */
        .PhoneInputCountry {
          display: flex;
          align-items: center;
          padding: 0 8px 0 10px;
          border-right: 1px solid ${tokens.colorNeutralStroke1};
          background: transparent;
          gap: 4px;
          height: 100%;
          margin: 0;
        }
        .PhoneInputCountrySelectArrow {
          color: ${tokens.colorNeutralForeground3};
          font-size: 10px;
          opacity: 1;
          border-style: solid;
          border-color: ${tokens.colorNeutralForeground3};
          border-width: 0 1.5px 1.5px 0;
          transform: rotate(45deg);
          margin-top: -3px;
          width: 5px;
          height: 5px;
        }
        .PhoneInputCountrySelect {
          position: absolute;
          top: 0; left: 0;
          width: 100%; height: 100%;
          opacity: 0;
          cursor: pointer;
        }
        .PhoneInputCountryIcon {
          width: 22px;
          height: 15px;
        }
        .PhoneInputCountryIcon--square {
          width: 20px;
          height: 20px;
        }
        /* Input pole */
        .PhoneInputInput {
          flex: 1;
          border: none;
          outline: none;
          background: transparent;
          font-family: ${tokens.fontFamilyBase};
          font-size: ${tokens.fontSizeBase300};
          color: ${tokens.colorNeutralForeground1};
          padding: 0 10px;
          height: 100%;
        }
        .PhoneInputInput::placeholder {
          color: ${tokens.colorNeutralForeground4};
        }
        .PhoneInputInput:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
      `}</style>
    </div>
  )
}
